<template>
  <div id="signin-fields">
    <form>
      <div class="row justify-content-center text-center">
        <div class="col-sm-6">
          <label for="email"><h3>Email</h3></label>
          <div class="row">
            <i class="fa fa-envelope col-2 icon fa-2x"></i> 
            <input ref="email" class="form-control col-10" type="email" placeholder="Example@Example.com" v-model="newUser.email" required />
          </div>
          <span v-if="message && message.email !== undefined" class="text-danger small">This email {{message.email[0]}}</span>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-6">
          <label for="password"><h3>Password</h3></label>
          <div class="row">
            <i class="fa fa-lock col-2 icon fa-2x"></i> 
            <input ref="password" class="form-control col-10" type="password" v-model="newUser.password" minlength="6"
            title="You must include a character from at least 3 of these categories: upper case, lower case, numbers, and special characters."
            pattern="^(?:(?!.*[<>])(?:(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[~!\[@#$%^&*()_,|`\]\{+=?.\}\\\/<>-])(?=.*[0-9])|(?=.*[~!\[@#$%^&*()_,|`\]\{+=?.\}\\\/<>-])(?=.*[a-z])(?=.*[A-Z])|(?=.*[~!\[@#$%^&*()_,|`\]\{+=?.\}\\\/<>-])(?=.*[0-9])(?=.*[A-Z]))).*$"
            required/>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-6">
          <label for="password_confirmation"><h3>Password Confirmation</h3></label>
          <div class="row">
            <i class="fa fa-lock col-2 icon fa-2x"></i> 
            <input ref="password-confirmation" class="form-control col-10" type="password" name="password_confrimation" v-model="newUser.password_confirmation" required />
          </div>
          <span v-if="message && message.password_confirmation !== undefined" class="text-danger small">This {{message.password_confirmation[0]}}</span>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-6">
          <label for="first name"><h3>First Name</h3></label>
          <div class="row">
            <i class="fa fa-user col-2 icon fa-2x"></i> 
            <input ref="first-name" class="form-control col-10" pattern=".*\S+.*" title="This field is required" type="text" name="first_name" v-model="newUser.first_name" required />
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-sm-6">
          <label for="last name"><h3>Last Name</h3></label>
          <div class="row">
            <i class="fa fa-user col-2 icon fa-2x"></i> 
            <input ref="last-name" class="form-control col-10" pattern=".*\S+.*" title="This field is required" type="text" name="last_name" v-model="newUser.last_name" required />
          </div>
        </div>
      </div>
      <br/>
      <div v-if="fedramp" class="row justify-content-center">
          <b-button @click="displaySystemUse"  class="btn btn-primary col-sm-6">Continue to Sign Up</b-button>
          <b-modal ref="system-use" id="modal-1" class="my-modal" title="System Use Notification" hide-footer size="lg">
            <div class="text-center">
              <h4>This is a notice that you are accessing a U.S. Government information system.</h4>
              <p>Information system usage may be monitored, recorded, and subject to audit.</p>
              <p>Unauthorized use of the information system is prohibited and subject to criminal and civil penalties.</p>
              <p>Use of the information system indicates consent to monitoring and recording.</p>
              <h4>Authorized Usage:</h4>
              <p>List all authorized uses of the information system.</p>
              <button @click="submitSignUp" type="submit" pattern=".*\S+.*" title="This field is required" class="btn col-sm-6 btn-primary" >Agree and Sign Up</button>
              <div v-if="message">
                <p class="text-danger small">This email had already been taken.</p>
              </div>
            </div>
          </b-modal>
      </div>
      <div v-else class="row justify-content-center">
        <button type="submit" @click="submitSignUp" pattern=".*\S+.*" title="This field is required" class="btn col-sm-6 btn-primary" >Sign Up</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from '../../auth.js'
export default {
  props: {
    nextPath: String
  }, 
  data(){
    return {
      fedramp: null,
      newUser:{
        email: '',
        password: '',
        password_confirmation: '',
        first_name:'',
        last_name:''
      },
      message: null
    }
  },
  mounted(){

    if (process.env.VUE_APP_FEDRAMP === "true") {
      this.fedramp = true
    } else {
      this.fedramp = false
    }

    // get request to set token before we post
    axios.get(
      `${process.env.VUE_APP_ENDPOINT}/users/sign_in/`
    )
  },
  methods:{
    displaySystemUse() {
      if (this.$refs['email'].validity.valid && this.$refs['password'].validity.valid &&
      this.$refs['password-confirmation'].validity.valid && this.$refs['first-name'].validity.valid &&
      this.$refs['last-name'].validity.valid) {
        this.$refs['system-use'].show()
      }
    },
    submitSignUp(event){
      event.preventDefault()
      axios.post(
        `${process.env.VUE_APP_ENDPOINT}/users/`,
        {
          user: {
            email: this.newUser.email,
            password: this.newUser.password,
            password_confirmation: this.newUser.password_confirmation,
            first_name: this.newUser.first_name,
            last_name: this.newUser.last_name,
            home_page: this.$store.state.afterLoginPath === "/" ? this.nextPath : this.$store.state.afterLoginPath
          }
        }
      )
      .then(res =>{
        localStorage.setItem("loggedIn", true)
        this.$store.commit('login', true)
        this.$store.commit('setUserName', res.data.first_name)
        this.$router.push({name: 'confirmAccount'})
        if (this.$store.state.afterLoginPath == "/") {
          this.$store.commit('setAfterLoginPath', this.$props.nextPath)
        }
      })
      .catch(e => {
        if(e.response.data.errors){
          this.message = e.response.data.errors
        }else{
          this.message = e.response.data.error
        }
        localStorage.setItem("loggedIn", false);
        this.$store.commit('login', false)
        this.$store.commit('setUserName', null)
        //this.$store.commit('setProfileData', {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.show
  {
    opacity: 0.5 !important;
    background-color: red !important;
  }


label {
  margin-bottom: 0px;
  margin-top: 1em;
}

.icon {
  color: #dcdcdc;
}

</style>
